module.exports = __webpack_public_path__ + "img/osfatun-1.3afe2111.svg";